import ShowroomMenuPopover from "./showroom-menu-popover";

export default ShowroomMenuPopover;